import classNames from 'classnames'
import { memo } from 'react'
import { Logo } from '@campgladiator/cgui-core.atoms.logo'
import { useDeviceWidth } from '../../../../common/hooks'
import { Link } from 'react-router-dom'
import { LoginHeaderProps } from '../../Login.d'
import styles from './LoginHeader.module.scss'

const logoSizeBreakpoint = 576

const LoginHeader = ({ className = '', ...props }: LoginHeaderProps) => {
  const deviceWidth = useDeviceWidth()

  return (
    <div className={classNames(styles.content, className)} {...props}>
      <Link to="/">
        <Logo
          className={styles.logo}
          type="icon"
          iconType="white"
          width={deviceWidth < logoSizeBreakpoint ? '35px' : '60px'}
        />
      </Link>
    </div>
  )
}

export default memo(LoginHeader)
